import { gql } from '@apollo/client';

export const INSERT_TIMETABLE_ITEM = gql`
  mutation insert_timetable_item($objects: [timetable_item_insert_input!]!) {
    insert_timetable_item(objects: $objects) {
      returning {
        id
        published
      }
    }
  }
`;

export const DELETE_TIMETABLE_ITEM = gql`
  mutation delete_timetable_item($where: timetable_item_bool_exp!) {
    delete_timetable_item(where: $where) {
      affected_rows
    }
  }
`;

export const UPDATE_TIMETABLE_ITEM = gql`
  mutation update_timetable_item($_set: timetable_item_set_input, $where: timetable_item_bool_exp!) {
    update_timetable_item(_set: $_set, where: $where) {
      returning {
        id
        published
      }
    }
  }
`;

export const STUDENT_TIMETABLE_ITEM = gql`
  query student_timetable_item($where: student_timetable_item_bool_exp) {
    student_timetable_item(where: $where) {
      id
      startTime
      endTime
      subjectName
      subjectExtraSlotName
    }
  }
`;

export const TIMETABLE_ITEMS = gql`
  query timetable_item($where: timetable_item_bool_exp) {
    timetable_item(where: $where) {
      id
      endTime
      startTime
      locationId
      batchClassId
      userId
      published
      batch_class {
        name
        batch {
          name
        }
      }
      batch_subject_configuration {
        id
        subject {
          name
          code
          color
        }
      }
      batch_subject_extra_slot {
        id
        name
        batch_subject_configuration {
          subject {
            name
            color
          }
        }
      }
    }
  }
`;

export const TIMETABLE_ITEMS_FOR_VIEW = gql`
  subscription timetable_items_for_view($where: timetable_item_bool_exp) {
    timetable_item(where: $where) {
      id
      startTime
      endTime
      batch_subject_configuration {
        subject {
          id
          code
          name
          color
        }
      }
      batch_subject_extra_slot {
        name
        batch_subject_configuration {
          subject {
            code
            name
            color
          }
        }
      }
      location {
        id
        name
      }
      batch_class {
        name
        batch {
          name
        }
      }
    }
  }
`;

export const TIMETABLE_ITEMS_FOR_STUDENT_VIEW = gql`
  subscription timetable_items_for_student_view($where: student_timetable_item_bool_exp) {
    student_timetable_item(where: $where) {
      id
      startTime
      endTime
      subjectCode
      subjectColor
      batchName
      subjectExtraSlotName
      subjectName
      lecturerLastName
      lecturerFirstName
      locationName
      studentFirebaseUID
    }
  }
`;

export const TIMETABLE_ITEM_FOR_ATTENDANCE = gql`
  query timetableItemForAttendance($where: timetable_item_bool_exp) {
    timetable_item(where: $where) {
      startTime
      endTime
      batch_subject_configuration {
        id
        batch {
          course {
            id
            name
          }
        }
        subject {
          name
        }
      }
      batch_subject_extra_slot {
        id
        name
        batch_subject_configuration {
          batch {
            course {
              id
              name
            }
          }
          subject {
            name
          }
        }
      }
      batch_class {
        id
        name
        batch {
          name
        }
      }
    }
  }
`;
